<template>
    <div class="wrapper hide--portable">
        <div class="heading">
            <BaseHeading
                heading="Discover"
                tag="h1"
            />

            <ul class="list">
                <li
                    class="list__item"
                    :class="{ 'list__item--selected': map === 'regions' }"
                    @click="selectMap('regions')"
                >
                    <BaseIcon icon="regions-icon" />
                    Regions
                </li>
                <li
                    class="list__item"
                    :class="{ 'list__item--selected': map === 'drives' }"
                    @click="selectMap('drives')"
                >
                    <BaseIcon icon="drive-times-icon" />
                    Drive Times
                </li>
                <li
                    class="list__item list__item--alt"
                    :class="{ 'list__item--selected': map === 'parks' }"
                    @click="selectMap('parks')"
                >
                    <BaseIcon icon="menu-parks-icon" />
                    National Parks
                </li>
                <li
                    class="list__item list__item--parent"
                    :class="{ 'list__item--selected': itineraryMapActive }"
                >
                    <div
                        class="drives-text"
                        @click="selectMap('itinerary-syd')"
                    >
                        <BaseIcon icon="menu-drive-itineraries-icon" />
                        Drive Itineraries
                    </div>
                    <ul class="drives-list" v-if="itineraryMapActive">
                        <li
                            :class="{ 'list__item--selected': map === 'itinerary-syd' }"
                            @click="selectMap('itinerary-syd')"
                        >
                            Melbourne to Sydney coastal drive
                        </li>
                        <li
                            :class="{ 'list__item--selected': map === 'itinerary-alpine' }"
                            @click="selectMap('itinerary-alpine')"
                        >
                            Great Alpine road
                        </li>
                        <li
                            :class="{ 'list__item--selected': map === 'itinerary-penguins' }"
                            @click="selectMap('itinerary-penguins')"
                        >
                            Penguins to prom drive
                        </li>
                        <li
                            :class="{ 'list__item--selected': map === 'itinerary-hinterland' }"
                            @click="selectMap('itinerary-hinterland')"
                        >
                            West Gippsland hinterland drive
                        </li>
                    </ul>
                </li>
            </ul>

        </div>
        <div class="map-wrapper">
            <div class="map-content">
                <slot name="parks" :active-park="activePark" :map="map"></slot>
                <slot name="regions" :active-region="activeRegion" :map="map"></slot>
                <slot name="drives" :map="map"></slot>
                <slot name="itinerary-syd" :map="map"></slot>
                <slot name="itinerary-alpine" :map="map"></slot>
                <slot name="itinerary-penguins" :map="map"></slot>
                <slot name="itinerary-hinterland" :map="map"></slot>

                <img class="map-content-bg" src="/dist/images/map/bg.svg" />
            </div>

            <div
                v-show="map === 'regions'"
                v-for="destination in regionsCardContent"
                :key="'region-' + destination.heading.split(' ')[0].toLowerCase()"
                :id="'region-' + destination.heading.split(' ')[0].toLowerCase()"
                class="map__card"
                :class="{'map__card--white' : destination.whiteText, 'map__card--active' : destination.heading.toLowerCase().includes(activeRegion) }"
            >
                <div class="map__card-upper" :style="{ backgroundImage: `url('${destination.image}')` }">
                    <h3 :class="{'text--white' : destination.whiteText }">{{ destination.subheading }}</h3>
                    <h2 class="h2" :class="{'text--white' : destination.whiteText }">{{ destination.heading }}</h2>
                </div>
                <div class="map__card-lower">
                    <p v-html="destination.summary"></p>
                    <BaseButton
                        modifier="small"
                        :href="destination.url">
                        Find out more
                    </BaseButton>
                </div>
            </div>

            <div
                v-show="map === 'parks'"
                v-for="park in parksCardContent"
                :key="'park-' + park.slug"
                :id="'park-' + park.slug"
                class="map__card map__card--compact"
                :class="{'map__card--active' : park.slug.includes(activePark) }"
            >
                <a class="map__card-upper">
                    <h3>{{ park.heading }}</h3>
                    <BaseButton
                        modifier="squared small"
                        :href="park.url"
                        align="left"
                    >
                        <BaseIcon
                            icon="arrow-left"
                            color="white"
                        />
                    </BaseButton>
                </a>
                <div class="map__card-lower" :style="{ backgroundImage: `url('${park.image}')` }">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ClickableMap',
    props: {
        regionsCardContent: Array,
        parksCardContent: Array
    },
    data() {
        return {
            map: 'regions',
            activeRegion: null,
            activePark: null
        }
    },
    mounted() {
        const regionLabels = Array.from(document.querySelectorAll('.region-label'));
        regionLabels.forEach((regionLabel) => {
            regionLabel.addEventListener('mouseenter', () => {
                this.activeRegion = regionLabel.dataset.region
            })
            regionLabel.addEventListener('mouseleave', () => {
                this.activeRegion = null;
            })
        })

        const regionCards = Array.from(document.querySelectorAll('.map__card:not(.map__card--compact)'));
        regionCards.forEach((regionCard) => {
            regionCard.addEventListener('mouseenter', () => {
                this.activeRegion = regionCard.id.split('-')[1];
            })
            regionCard.addEventListener('mouseleave', () => {
                this.activeRegion = null;
            })
        })

        const parkCards = Array.from(document.querySelectorAll('.map__card.map__card--compact'));
        parkCards.forEach((parkCard) => {
            parkCard.addEventListener('mouseenter', () => {
                this.activePark = parkCard.id;
            })
            parkCard.addEventListener('mouseleave', () => {
                this.activePark = null;
            })
        })

        const regions = Array.from(document.querySelectorAll('.region'));
        regions.forEach((region) => {
            region.addEventListener('mouseenter', () => {
                this.activeRegion = region.dataset.region
            })
            region.addEventListener('mouseleave', () => {
                this.activeRegion = null;
            })
        })

        const parks = Array.from(document.querySelectorAll('.park'));
        parks.forEach((park) => {
            park.addEventListener('mouseenter', () => {
                this.activePark = park.dataset.park
            })
            park.addEventListener('mouseleave', () => {
                this.activePark = null;
            })
        })
    },
    methods: {
        selectMap(map) {
            this.$data.map = map
        },
        selectItinerary(itinerary) {
            console.log(itinerary)
            this.selectMap(itinerary);
            this.$data.itineraryMapActive = true
        }
    },
    computed: {
        itineraryMapActive() {
            return this.map.includes('itinerary');
        }
    }
}
</script>

<style lang="scss" scoped>
    .wrapper {
        position: relative;
    }

    .heading {
        z-index: 1;
        position: absolute;
        margin-top: 150px;
        margin-left: 30px;

        @include media-query('desk') {
            margin-top: 50px;
        }

        @include media-query('desk-wide') {
            margin-top: 90px;
        }

        @include media-query('portable') {
            margin-top: 50px;
            position: relative;
        }

        @include media-query('palm') {
            margin-top: 0;
        }
    }

    .list {
        margin-top: 35px;
        list-style: none;
        display: inline-block;

        @include media-query('portable') {
            display: flex;
            flex-wrap: wrap;
        }
    }

    .list__item {
        position: relative;
        display: flex;
        margin: 10px 0;
        padding: 15px 20px;
        align-items: center;
        color: #505C63;
        font-size: 0.75rem;
        font-weight: bold;
        letter-spacing: 0.75px;
        text-transform: uppercase;
        border-radius: 100px;
        cursor: pointer;

        @include media-query('portable') {
            width: 95%;
            margin: 5px 0;
        }

        .BaseIcon {
            color: #C9C4BC;
            margin-right: 10px;
            width: 0.9rem;
            height: 0.9rem;
        }

        &--selected {
            color: #ffffff;
            background-color: #023C48;

            .drives-list {
                display: block;
            }

            .BaseIcon {
                color: #ffffff
            }
        }

        &--alt {
            .BaseIcon {
                height: 1.2rem;
                margin-top: -.2rem;
            }
        }

        &:last-child.list__item--selected {
            margin-bottom: 200px;
            border-radius: 20px 20px 0 0;
        }
    }

    .list__item--parent {
        &--selected {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        li {
            background-color: #023C48;
            color: #ffffff;
            padding-left: 19px;
            padding-top: 10px;
            line-height: 1.4em;
            padding-bottom: 10px;
            font-size: 14px;
            border-top: 1px solid #187689;

            &:first-child {
                margin-top: 15px;
            }

            &.list__item--selected {
                background-color: #509050;
            }
        }
    }

    .map-wrapper {
        position: relative;
    }

    .map-content {
        width: 100%;
        position: relative;

        > div > svg, img:not(.map-content-bg) {
            width: 100%;
            position: relative;
        }
    }

    .map-content-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        z-index: -1;
    }

    .map__card {
        width: 420px;
        box-shadow: 0 0 15px rgba(0,0,0,0.1);
        background-color: #ffffff;
        position: absolute;
        max-height: 0px;
        opacity: 0;
        transition: .4s;
        z-index: 10;
        overflow: hidden;

        @include media-query('portable') {
            width: 300px;
        }

        &:hover {
            opacity: 1;
            max-height: 900px;
            z-index: 10;
        }

        .map__card-upper:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(255,255,255,0.2);
            left: 0;
            top: 0;
            z-index: -1;
        }
    }

    .map__card--compact {
        width: 200px;

        h3 {
            margin-right: 15px;
            font-family: $base-font-family !important;
            font-size: 12px;
            text-transform: uppercase;
            font-weight: 800;
            color: #000000;
        }

        .map__card-upper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px;
            text-align: left;
        }

        .map__card-lower {
            height: 100px;
            background-size: cover;
            background-position: center;
        }

        .BaseButton {
            flex-shrink: 0;
        }
    }

    .map__card--active {
        @include media-query(desk) {
            opacity: 1;
            max-height: 900px;
        }
    }

    .map__card--white {
        .map__card-upper:before {
            background-color: rgba(0,0,0,0.2);
        }
    }

    .map__card-upper {
        position:  relative;
        background-size: cover;
        background-position: center;
        padding: 40px 20px;
        text-align: center;
        z-index: 0;

        @include media-query('portable') {
            padding: 30px 15px;
        }

        h3 {
            font-family: $fancy-font-family;
        }

        h2 {
            font-size: 35px;
        }
    }

    .map__card-lower {
        padding: 30px;
        text-align: center;

        @include media-query('portable') {
            padding: 20px;
        }

        p {
            margin-bottom: 20px;
            font-size: 18px;

            @include media-query('portable') {
                font-size: 16px;
            }
        }
    }

    .region {
        cursor: pointer;
    }

    #region-west {
        left: 25%;
        top: 4%;

        @include media-query('desk-wide') {
            top: 12%;
        }
    }

    #region-phillip {
        left: 14%;
        top: 13%;

        @media only screen and (min-width: 1140px) {
            top: 19%;
        }

        @media only screen and (min-width: 1280px) {
            top: 25%;
        }

        @include media-query('desk-wide') {
            left: 19%;
            top: 29%;
        }
    }

    #region-south {
        left: 18%;
        top: 24%;

        @include media-query('desk-wide') {
            top: 28%;
        }
    }

    #region-central {
        left: 35%;
        top: 1%;

        @include media-query('desk-wide') {
            top: 5%;
        }
    }

    #region-east {
        right: 15%;
        top: 48%;
    }

    #park-bunurong-coast {
        left: 26%;
        bottom: 38%;

        @include media-query('desk') {
            left: 26%;
            bottom: 34%;
        }

        @include media-query('desk-wide') {
            left: 26%;
            bottom: 29%;
        }
    }

    #park-coopracambra-national-park {
        top: 20%;
        right: 12%;

        @include media-query('desk') {
            top: 16%;
            right: 15%;
        }

        @include media-query('desk-wide') {
            top: 14%;
            right: 15%;
        }
    }

    #park-point-hicks-marine-national-park {
        top: 49%;
        right: 15%;
    }

    #park-croajingolong-national-park {
        top: 25%;
        right: 11%;

        @include media-query('desk') {
            top: 24%;
            right: 14%;
        }

        @include media-query('desk-wide') {
            top: 24%;
            right: 14%;
        }
    }

    #park-cape-liptrap-coastal-park {
        top: 48%;
        left: 30%;

        @include media-query('desk') {
            top: 51%;
            left: 30%;
        }

        @include media-query('desk-wide') {
            top: 57%;
            left: 30%;
        }
    }

    #park-baw-baw-national-park {
        top: 26%;
        left: 34%;
    }

    #park-alpine-national-park {
        top: 37%;
        right: 38%;

        @include media-query('desk') {
            top: 34%;
            right: 38%;
        }

        @include media-query('desk-wide') {
            top: 31%;
            right: 38%;
        }
    }

    #park-the-lakes-national-park {
        top: 32%;
        right: 35%;

        @include media-query('desk') {
            top: 35%;
            right: 35%;
        }

        @include media-query('desk-wide') {
            top: 35%;
            right: 35%;
        }
    }

    #park-tarra-bulga-national-park {
        top: 37%;
        left: 38%;

        @include media-query('desk') {
            top: 40%;
            left: 38%;
        }

        @include media-query('desk-wide') {
            top: 43%;
            left: 38%;
        }
    }

    #park-ninety-mile-beach {
        top: 32%;
        right: 34%;

        @include media-query('desk') {
            top: 36%;
            right: 37%;
        }

        @include media-query('desk-wide') {
            top: 39%;
            right: 37%;
        }
    }

    #park-snowy-river-national-park {
        top: 20%;
        right: 22%;

        @include media-query('desk') {
            top: 18%;
            right: 27%;
        }

        @include media-query('desk-wide') {
            top: 18%;
            right: 27%;
        }
    }

    #park-cape-conran {
        top: 27%;
        right: 18%;

        @include media-query('desk') {
            top: 27%;
            right: 22%;
        }

        @include media-query('desk-wide') {
            top: 27%;
            right: 22%;
        }
    }

    #park-lind-national-park {
        top: 24%;
        right: 12%;

        @include media-query('desk') {
            top: 22%;
            right: 19%;
        }

        @include media-query('desk-wide') {
            top: 22%;
            right: 19%;
        }
    }

    #park-errinundra-national-park {
        top: 20%;
        right: 14%;

        @include media-query('desk') {
            top: 16%;
            right: 18%;
        }

        @include media-query('desk-wide') {
            top: 14%;
            right: 22%;
        }
    }

    #park-buchan-caves {
        top: 20%;
        right: 23%;

        @include media-query('desk') {
            top: 20%;
            right: 28%;
        }

        @include media-query('desk-wide') {
            top: 18%;
            right: 33%;
        }
    }

    #park-gippsland-lakes-coastal-park {
        top: 30%;
        right: 34%;
    }

    #park-mitchell-river-national-park {
        top: 56%;
        right: 50%;

        @include media-query('desk') {
            top: 56%;
            right: 55%;
        }

        @include media-query('desk-wide') {
            top: 56%;
            right: 55%;
        }
    }

    #park-nooramunga-marine-coastal-parks {
        top: 44%;
        right: 49%;

        @include media-query('desk') {
            top: 48%;
            right: 49%;
        }

        @include media-query('desk-wide') {
            top: 54%;
            right: 49%;
        }
    }

    #park-wilsons-promontory {
        top: 48%;
        right: 50%;

        @include media-query('desk') {
            top: 53%;
            right: 50%;
        }

        @include media-query('desk-wide') {
            top: 60%;
            right: 50%;
        }
    }

    #park-corner-inlet {
        top: 45%;
        right: 50%;

        @include media-query('desk') {
            top: 50%;
            right: 54%;
        }

        @include media-query('desk-wide') {
            top: 55%;
            right: 54%;
        }
    }

    #park-shallow-inlet{
        top: 47%;
        right: 53%;

        @include media-query('desk') {
            top: 51%;
            right: 53%;
        }

        @include media-query('desk-wide') {
            top: 56%;
            right: 53%;
        }
    }

    #park-morwell-national-park {
        top: 36%;
        left: 35%;

        @include media-query('desk') {
            top: 39%;
            left: 35%;
        }

        @include media-query('desk-wide') {
            top: 42%;
            left: 35%;
        }
    }

    #park-mitchell-river-national-park {
        top: 25%;
        right: 38%;
    }

    .region {
        transition: .5s;
    }

    .region.active {
        @include media-query(desk) {
          filter:url(#dropshadow);
          transform: translateY(-7px);
        }
    }
    .outline {
        opacity: 1;
        transition: 0.5s;
    }
    .hide {
        opacity: 0;
    }

    .drives-list {
        display: none;
        box-shadow: 0 5px 35px 0 rgba(0,0,0,0.20);
        position: absolute;
        width: 100%;
        left: 0;
        top: 45px;
        background-color: #023C48;
        border-radius: 2px 2px 21px 21px;
        overflow: hidden;

        li:first-child {
            margin-top: 0;
        }
    }

    .drives-list__item {
        border-top: 1px solid #187689;
        padding: 15px 20px;
        color: #ffffff;
        text-transform: uppercase;

        &--selected {
            background-color: #509050;
            border-color: #509050;
        }

        &:hover {
            background-color: #509050;
            border-color: #509050;
        }
    }

    .drives-text {
        z-index: 1;
        display: flex;
        align-items: center;
        width: 100%;

        .list__item--selected & {
            color: #ffffff;
            padding: 0 20px;
            width: calc(100% + 40px);
            border-radius: 30px 30px 0 0;
            margin-left: -20px;
            margin-right: -20px;
        }
    }
</style>